/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * N-8 (FCR S732): the methods that do the same thing however many times they
 * run. An automatic retry is only safe for these -- the rule common HTTP clients
 * use by default (axios-retry's isNetworkOrIdempotentRequestError retries GET,
 * HEAD, OPTIONS, PUT and DELETE).
 *
 * The method was never checked, so a POST was retried exactly like a GET: an
 * account-deletion confirmation that took longer than its ten-second limit was
 * sent a second time with a code that had already been used, and the customer
 * whose account HAD been deleted was told the code was invalid. Trial requests
 * and password e-mails were sent twice the same way.
 */
export const IDEMPOTENT_METHODS = new Set(["get", "head", "options", "put", "delete"]);

export const mayRetryAutomatically = (config: {
  method?: string;
  retryUnsafe?: boolean;
}): boolean =>
  IDEMPOTENT_METHODS.has((config.method || "get").toLowerCase()) || config.retryUnsafe === true;
